// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var IVotingType;
(function (IVotingType) {
    IVotingType["NON_PREFERENTIAL"] = "non-preferential";
})(IVotingType || (IVotingType = {}));
export var ICountingAlgorithm;
(function (ICountingAlgorithm) {
    ICountingAlgorithm["PLURALITY_AT_LARGE"] = "plurality-at-large";
})(ICountingAlgorithm || (ICountingAlgorithm = {}));
